import React, {useState, useEffect, useContext} from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Menu from "../include/Menu";
import Footer from "../include/Footer";
import ProposalsDao from "./ProposalsDao";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import NewProposalModal from "./NewProposalModal.js";
import Context from "../../../context/context";
import DAO from '../abi/Dao.json';
import TransactionStatus from "../TxnStatus";
import { providerURL } from '../../../helper/Helper';

const DaoIndex = () => {
  const { account, onConnect, plsPrice} = useContext(Context);
  const [availablePLS, setAvailablePLS] = useState(0);
  const [proposalPLS, setProposalPLS] = useState(0);
  const [totalPLS, setTotalPLS] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openNewProposal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  
  useEffect(() => {
      let cancelled = false;
      if (!cancelled) {
          AOS.init({
              duration: 1000,
              once: true,
          });
          getData();
      }
      return () => {
        cancelled = true;
      };
  }, []);

  const getData = async () => {
    const web3 = new Web3(providerURL());
    const daoContract = new web3.eth.Contract(DAO.ABI, DAO.Contract);

    const totalPLS = parseFloat(parseInt(await web3.eth.getBalance(DAO.Contract)) / 10**18).toFixed(2);
    const lockedPLS = parseFloat(parseInt(await daoContract.methods.lockedAmount().call()) / 10**18).toFixed(2);
    const availablePLS = parseFloat(totalPLS - lockedPLS).toFixed(2);

    setAvailablePLS(availablePLS);
    setProposalPLS(lockedPLS);
    setTotalPLS(totalPLS);
  }

  return (
  <>
  <Menu />
  <section className="PTGCSEC slideSecInner slideSec leftrightSecSpace">
      <div className="1 relative">
          <div className="row justify-content-between align-items-center">
              <div className="col-xl-7">
                  <div className="sliderContent">
                      <h1 className='good_times goldFont' data-aos="fade-up" data-aos-delay="300" data-aos-duration="600"><img src="./images/logoName.svg" className="img-fluid logoNameInnerPage m-0" /><span>Dao</span></h1>
                      <p className='mt-0' data-aos="fade" data-aos-delay="500" data-aos-duration="800">PTGCs DAO is a decentralized system empowering PTGC stakers to adapt and thrive in the dynamic crypto landscape while maintaining true decentralization, free from control by any single entity.</p>
                      <div className="bottomSliderBtn" data-aos="fade-right" data-aos-delay="700" data-aos-duration="1000">
                          <div className="d-flex gap-3 align-items-center">
                              {
                                account ? 
                                <>
                                  <button onClick={openNewProposal}  className="borderbtn mybtn">
                                  <span>Make New Proposal</span>
                                    <img src="./images/circle_arrow.svg" className="img-fluid" />
                                  </button>
                                </>
                                :
                                <>
                                <button onClick={onConnect} className="borderbtn mybtn">
                                  <span>Connect Wallet</span>
                                  <img src="./images/circle_arrow.svg" className="img-fluid" />
                                </button>
                                </>
                              }
                              <a href="https://scan.pulsechain.com/address/0x305ACfAb82103c2b82B19543919d1c93b44E55DB" target="_blank" rel="noopener noreferrer" className="mybtn underline text-white"><span>View DAO Contract</span></a>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-xl-4 slR" data-aos="fade-left" data-aos-delay="700" data-aos-duration="1000">
                  <div className="bottomSliderRight ">
                      <div className="bSRIN overHide">
                          <div className="snPortal border0">
                              <div className="SRTOP  ">
                                <div className="row   align-items-center borderBottom p-0">
                                  <div className="col-sm-6">
                                    <div className="mb-3 ">
                                        <span className="d-block">Available PLS</span>
                                        <div className="dollorVal d-inline-block f28  mt-0 mb-0">
                                            <span className="dollor dollor1">$</span>
                                            <span className="val valgold we400 f28">{parseFloat(availablePLS * plsPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div className="perVal fInter ">
                                            <span>{parseFloat(availablePLS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PLS</span>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="mb-3 ">
                                        <span className="d-block fInter">PLS in Proposals </span>
                                        <div className="dollorVal d-inline-block f28  mt-0 mb-0">
                                            <span className="dollor dollor1">$</span>
                                            <span className="val valgold we400 f28">{parseFloat(proposalPLS * plsPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div className="perVal fInter ">
                                            <span>{parseFloat(proposalPLS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PLS</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row   align-items-center borderBottom p-0 ">
                                  <div className="col-sm-6">
                                    <div className="mb-3 mt-3">
                                        <span className="d-block fInter">Total PLS in DAO</span>
                                        <div className="dollorVal d-inline-block f28  mt-0 mb-0">
                                            <span className="dollor dollor1">$</span>
                                            <span className="val valgold we400 f28">{parseFloat(totalPLS * plsPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                        </div>
                                        <div className="perVal fInter ">
                                            <span>{parseFloat(totalPLS).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PLS</span>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                          <div className="mt-0 amountSTaking">
                              {
                                account ?
                                <>
                                  <button onClick={openNewProposal} className="mb_down1 borderbtn mybtn w-100 d-flex justify-content-between align-items-center">
                                    <span>Make New Proposal</span> <img className="img-fluid" src="./images/circle_arrow.svg" />
                                  </button>
                                </>
                                :
                                <>
                                  <button className="mb_down1 borderbtn mybtn w-100 d-flex justify-content-between align-items-center" disabled>
                                    <span>Make New Proposal</span> <img className="img-fluid" src="./images/circle_arrow.svg" />
                                  </button>
                                </>
                              }
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <ProposalsDao />
  <TransactionStatus />
  <NewProposalModal modalIsOpen={modalIsOpen} closeModal={closeModal} />
  <Footer />
  </>
  );
};

export default DaoIndex;